import { jsx as _jsx } from "react/jsx-runtime";
import { StyledBarChart } from "./styled";
export const BarChart = props => {
    return _jsx(StyledBarChart, { ...props });
};
